import './Technologies.css'
import { useBackground } from '../BackgroundContext';
// import Github from './Images/Technologies/github-dark.svg'
import { useState, useEffect, useMemo } from 'react';


function Technologies() {
  // eslint-disable-next-line react-hooks/exhaustive-deps
    const { theme } = useBackground();
    const [flippedIndexes, setFlippedIndexes] = useState(new Set());
    const [scrollPosition, setScrollPosition] = useState(0);
    
    
    
    useEffect(() => {
      const handleScroll = () => {
        setScrollPosition(window.scrollY); 
      };
      
      window.addEventListener('scroll', handleScroll); 
      return () => window.removeEventListener('scroll', handleScroll); 
    }, []);
    
    const fontSize = Math.min(6, 0 + scrollPosition / 305) + 'em';
    
    const getThemeClass = () => {
      if (theme.background === "#2e2e2e") return "dark-theme";
      if (theme.background === "white") return "light-theme";
      return "light-theme"; // Default
    };
    
    const numberWords = ["one", "two", "three", "four", "five", 
    "six", "seven", "eight", "nine", "ten", 
    "eleven", "twelve", "thirteen",
    "fourteen", "fifteen", "sixteen", "seventeen"];
    
    const stack = useMemo(() => {
      const baseStack = [
        "AE.svg", "React.svg", "Linux.svg", "CSS.svg", "vue.svg", "HTML.svg",
        "Figma.svg", "Github.svg", "js.svg", "Laravel.svg" ];
        if(theme.background === "#2e2e2e") {
          return baseStack.map(icon => 
            icon === "Github.svg" ? "github-dark.svg" : icon
            )
          }
          return baseStack
        }, [theme]) ;
        
        useEffect(() => {
          const interval = setInterval(() => {
            const randomIndex = Math.floor(Math.random() * stack.length);
            setFlippedIndexes((prev) => {
              const newFlipped = new Set(prev);
              if (newFlipped.has(randomIndex)) {
                newFlipped.delete(randomIndex);
              } else {
                newFlipped.add(randomIndex);
              }
              return newFlipped;
            });
          }, Math.random() * 1500 + 1000); 
          
          return () => clearInterval(interval);
        }, [stack.length]);

      const stackTwo = ["jira.svg","Azure.svg",
      "MongoDB.svg", "npm.svg", "postgres.svg",
      "sass.svg", "sql.svg", "Docker.svg"]
      
  return (
    <div className={`tech-page ${getThemeClass()}`} id="tech">
        <div className='group-img'>
          {stack.map((tech, index) => (
              <div
              key={index}
              className={`flip-card ${flippedIndexes.has(index) ? "flipped" : ""}`}
              id={numberWords[index] || `tech-${index + 1}`}
            >
              <div className="flip-inner">
                <img
                  className="flip-front"
                  src={`/Images/Technologies/${tech}`}
                  alt={`front ${index}`}
                />
                <img
                  className="flip-back"
                  src={`/Images/Technologies/${stackTwo[index % stackTwo.length]}`}
                  alt={`back ${index}`}
                />
              </div>
            </div>
            ))}
        </div>
        <h1 style={{fontSize}}>Tech Stack</h1>
    </div>
  );
}

export default Technologies;